/*eslint-disable*/

import React from "react";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";

interface EditableSelectFieldProps {
    label: string;
    name: string;
    value: string;
    isEditing: boolean;
    isEditable?: boolean;
    options: { value: string; label: string }[];
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    fontSize?: string; // Optional font size prop
}

const EditableSelectField: React.FC<EditableSelectFieldProps> = ({
    label,
    name,
    value,
    isEditing,
    isEditable = true,
    options,
    onChange,
    fontSize = "1rem", // Default font size if none is provided
}) => {
    return (
        <FormControl variant="standard" fullWidth>
            <InputLabel
                sx={{
                    fontSize: "16px", // Set the font size to match TextField
                    position: "absolute", // Position the label absolutely inside the FormControl
                    top: "-12px", // Adjust the top position for proper alignment with the input field
                    left: 0, // Ensure it starts at the very left
                    marginLeft: 0, // Remove any left margin (if applied by default)
                    "&.MuiInputLabel-shrink": {
                        top: -12, // Shrink label and move up when the input is focused or has a value
                    },
                }}
                className="mt-3 text-gray-100"
            >
                {label}
            </InputLabel>
            <Select
                name={name}
                value={value}
                onChange={onChange}
                disabled={!isEditing || !isEditable}
                variant="standard"
                // sx={{
                //     "& .MuiInputBase-input.Mui-disabled": {
                //         WebkitTextFillColor: isEditable
                //             ? "black !important"
                //             : "#6b7280 !important",
                //     },
                // }}
                disableUnderline={!isEditing} // Remove the underline when disabled
                sx={{
                    input: {
                        color: isEditable
                            ? "black !important"
                            : "#6b7280 !important",
                        fontSize, // Apply font size to input
                        padding: "0px 0px", // Adjust padding inside the input field
                    },
                    "& .MuiInputBase-input": {
                        textAlign: "left", // Left-align the selected value text
                        fontSize,
                    },
                    "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: isEditable
                            ? "black !important"
                            : "#6b7280 !important",
                        fontSize, // Apply font size to input when disabled
                        padding: "0px 0px", // Adjust padding inside the input field
                    },
                    // Remove the bottom border when disabled
                    "& .MuiInput-underline:before": {
                        borderBottom: !isEditing
                            ? "none !important"
                            : "1px solid rgba(0, 0, 0, 0.42)", // Remove underline when not editing or disabled
                    },
                    // Remove the bottom border after focus (when disabled)
                    "& .MuiInput-underline:after": {
                        borderBottom: !isEditing
                            ? "none !important"
                            : "1px solid rgba(0, 0, 0, 0.42)", // Remove underline after focus when disabled
                    },
                    // Remove the dotted border specifically when the component is disabled
                    "& .MuiInput-underline.Mui-disabled:before": {
                        borderBottom: "none !important", // Completely remove the dotted border when disabled
                    },
                    // Ensure no hover effect when disabled
                    "& .MuiInput-underline:hover:before": {
                        borderBottom: !isEditing
                            ? "none !important"
                            : "1px solid rgba(0, 0, 0, 0.42)",
                    },
                    boxShadow: "none",
                    ".MuiOutlinedInput-notchedOutline": { border: 0 },
                }}
            >
                {options.map((option) => (
                    <MenuItem
                        key={option.value}
                        value={option.value}
                        sx={{ fontSize }}
                    >
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default EditableSelectField;
